<template>
  <div style="width: 100%">
    <div class="page flex-col rag-workbench-page">
      <div class="group_1 flex-col">
        <div class="box_1 flex-col justify-end">
          <site-header />
          <div v-if="false" class="group_2 flex-col">
            <div class="box_2 flex-row">
              <div class="flex-row" style="align-items: center;">
                <img
                  class="image_1"
                  src="../assets/v2/img/logo-black.png"
                  alt="logo"
                  referrerpolicy="no-referrer"
                  data-track-text="首页Logo"
                  aria-label="首页Logo"
                  @click="toPath('/index')"
                />
                <span class="text_1">
                  <span data-track-text="首页" aria-label="首页" @click="toPath('/index')">首页</span>
                  <span>
                    <el-dropdown @command="gotoPage">
                      <span data-track-text="产品" aria-label="产品">产品</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="text" style="z-index: 1; font-weight: 800">文本翻译</el-dropdown-item>
                        <el-dropdown-item command="doc" style="z-index: 1; font-weight: 800">文档翻译</el-dropdown-item>
                        <el-dropdown-item command="ai" style="z-index: 1; font-weight: 800">AI翻译</el-dropdown-item>
                        <el-dropdown-item command="lange" style="z-index: 1; font-weight: 800">多语种翻译</el-dropdown-item>
                        <el-dropdown-item command="polish" style="z-index: 1; font-weight: 800">润色改写</el-dropdown-item>
                        <el-dropdown-item command="aiPPT" style="z-index: 1; font-weight: 800">AI PPT</el-dropdown-item>
                        <el-dropdown-item command="rag" style="z-index: 1; font-weight: 800; position: relative;">
                          <span>RAG知识库</span>
                          <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute; top: 2px; right: 5px; width: 18px; height: auto;" />
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <img
                      class="thumbnail_4"
                      referrerpolicy="no-referrer"
                      src="../assets/v2/img/trans/operate.png"
                    />
                  </span>
                  <span>
                    <el-dropdown @command="handleServiceCommand">
                      <span data-track-text="服务" aria-label="服务">服务</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="toTransPro" style="z-index: 1; font-weight: 800">人工翻译</el-dropdown-item>
                        <el-dropdown-item command="standLangSet" style="z-index: 1; font-weight: 800">术语词库</el-dropdown-item>
                        <el-dropdown-item command="convertDoc" style="z-index: 1; font-weight: 800">文档转换</el-dropdown-item>
                        <el-dropdown-item command="mySelfDoc" style="z-index: 1; font-weight: 800">我的文档</el-dropdown-item>
                        <el-dropdown-item command="webTranslate" style="z-index: 1; font-weight: 800; position: relative;">
                          <span>网页翻译</span>
                          <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute; top: 2px; right: 5px; width: 18px; height: auto;" />
                        </el-dropdown-item>
                        <el-dropdown-item command="smartClassify" style="z-index: 1; font-weight: 800; position: relative;">
                          <span>数据分析</span>
                          <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute; top: 2px; right: 5px; width: 18px; height: auto;" />
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <img
                      class="thumbnail_4"
                      referrerpolicy="no-referrer"
                      src="../assets/v2/img/trans/operate.png"
                    />
                  </span>
                </span>
              </div>
              <div class="flex-row" style="align-items: center;">
                <img
                  class="thumbnail_1"
                  referrerpolicy="no-referrer"
                  src="../assets/v2/img/trans/help.png"
                  data-track-text="帮助"
                  aria-label="帮助"
                  @click="toPath('/help')"
                />
                <span class="text_2" data-track-text="帮助" aria-label="帮助" @click="toPath('/help')">帮助</span>
                <template v-if="userInfo">
                  <img
                  class="thumbnail_1"
                  referrerpolicy="no-referrer"
                  src="../assets/v2/img/trans/login.png"
                  data-track-text="个人中心"
                  aria-label="个人中心"
                  @click="handleUserCommand('center')"
                />
                  <el-dropdown
                    @command="handleUserCommand"
                    style="display: flex; font-size: 14px; font-family: Microsoft YaHei; font-weight: 400; color: var(--foreground-secondary);"
                  >
                    <span class="text_2">{{ userInfo }}</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="center">个人中心</el-dropdown-item>
                        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                      </el-dropdown-menu>
                  </el-dropdown>
                </template>
                <span v-else class="text_2">
                  <span data-track-text="登录" aria-label="登录" @click="showIframe('/login')">登录</span>
                  <span>/</span>
                  <span data-track-text="注册" aria-label="注册" @click="showIframe('/register')">注册</span>
                </span>
              </div>
            </div>
          </div>

          <div class="group_3 flex-col">
            <div class="new-container">
              <div class="box_5 flex-row">
                <nav class="site-tool-sidebar" aria-label="全部功能">
                  <section
                    v-for="section in siteToolSections"
                    :key="section.key"
                    class="site-tool-section"
                  >
                    <h2 class="site-tool-section-title">{{ section.title }}</h2>
                    <div class="site-tool-list">
                      <button
                        v-for="item in section.items"
                        :key="item.text"
                        type="button"
                        class="site-tool-item"
                        :class="{ active: item.url === '/rag' }"
                        :data-track-text="item.text"
                        :aria-label="item.text"
                        :aria-current="item.url === '/rag' ? 'page' : null"
                        @click="navigateToSiteTool(item)"
                      >
                        <i class="site-tool-icon" :class="item.icon" aria-hidden="true"></i>
                        <span class="site-tool-name">{{ item.text }}</span>
                      </button>
                    </div>
                  </section>
                </nav>

                <div class="menu rag-menu" :class="{ 'menu-conversation': hasConversationSidebar }">
                  <div class="menu-type">
                    <div class="title">RAG功能</div>
                    <div class="menu-item flex-row align-center" data-track-text="知识库" aria-label="知识库" :class="{ active: activeTab === 'knowledge' }" @click="selectRagTab('knowledge')">
                      <i class="menu-icon el-icon-folder-opened"></i>
                      <span class="menu-name">知识库</span>
                    </div>
                    <div class="menu-item flex-row align-center" data-track-text="对话" aria-label="对话" :class="{ active: activeTab === 'conversation' }" @click="selectRagTab('conversation')">
                      <i class="menu-icon el-icon-message"></i>
                      <span class="menu-name">对话</span>
                    </div>
                  </div>

                  <div v-if="hasConversationSidebar" class="conversation-menu">
                    <div class="conversation-menu-head">
                      <div class="conversation-menu-title">会话</div>
                      <el-button class="conversation-create-btn" data-track-text="新建RAG会话" aria-label="新建RAG会话" type="primary" size="mini" @click="createSession">新建</el-button>
                    </div>
                    <div class="conversation-menu-list">
                      <div v-for="group in conversationSessionGroups" :key="group.key" class="conversation-menu-group">
                        <div class="conversation-menu-group-title">{{ group.label }}</div>
                        <div
                          v-for="item in group.items"
                          :key="item.sessionId"
                          class="conversation-menu-item"
                          data-track-text="打开RAG会话"
                          aria-label="打开RAG会话"
                          :class="{ active: item.sessionId === currentSessionId }"
                          @click="openSessionFromSidebar(item)"
                        >
                          <div class="conversation-menu-main">
                            <div class="conversation-menu-name">{{ item.title }}</div>
                            <div class="conversation-menu-meta">{{ item.updateTime || item.createTime || '刚刚创建' }}</div>
                          </div>
                          <i class="el-icon-delete conversation-menu-delete" data-track-text="删除RAG会话" aria-label="删除RAG会话" @click.stop="deleteSession(item)"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="rag-main">
                  <rag-knowledge-base-panel
                    v-if="activeTab === 'knowledge'"
                    :loading="knowledgeBaseLoading"
                    :file-upload-accept="knowledgeUploadAccept"
                    :uploading="knowledgeBaseDocumentUploading"
                    :knowledge-bases="knowledgeBases"
                    :current-knowledge-base="currentKnowledgeBase"
                    :detail-loading="knowledgeBaseDetailLoading"
                    :document-loading="knowledgeBaseDocumentLoading"
                    :documents="knowledgeBaseDocuments"
                    @refresh="loadKnowledgeBases"
                    @create-knowledge-base="createKnowledgeBase"
                    @update-knowledge-base="updateKnowledgeBase"
                    @open-knowledge-base="openKnowledgeBase"
                    @delete-knowledge-base="deleteKnowledgeBase"
                    @refresh-detail="refreshKnowledgeBaseDetail"
                    @refresh-documents="refreshKnowledgeBaseDocuments"
                    @upload="uploadKnowledgeBaseFile"
                    @delete-document="deleteKnowledgeBaseDocument"
                    @back-to-list="backToKnowledgeBaseList"
                  />

                  <rag-conversation-panel
                    v-if="activeTab === 'conversation'"
                    :current-session-id="currentSessionId"
                    :knowledge-bases="knowledgeBases"
                    :messages="messages"
                    :message-text="messageText"
                    :selected-knowledge-base-ids="selectedKnowledgeBaseIds"
                    :sending="sending"
                    @change-knowledge-bases="handleKnowledgeBaseSelection"
                    @update-message="messageText = $event"
                    @require-auth="requestRagAuthentication"
                    @send-message="sendMessage"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="false" class="text-wrapper_9 flex-col">
            <span class="paragraph_9">
              ©&nbsp;2020&nbsp;北京容智科技发展有限公司&nbsp;<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer">京ICP备19036872号-3</a>
              &nbsp;All&nbsp;rights&nbsp;reserved.&nbsp;京公网安备&nbsp;
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402010815" target="_blank" rel="noopener noreferrer">11011402010815</a><br />
              联系邮箱：<a href="mailto:info@wiseivy.com.cn?subject=微思翻译咨询">info&#64;wiseivy.com.cn</a>&nbsp;联系电话：010-80755328
            </span>
          </div>
          <site-footer class="rag-site-footer" />
        </div>
      </div>
      <floating-contact-tools />
    </div>
  </div>
</template>

<script>
import { Base64 } from 'js-base64'
import RagConversationPanel from './modules/rag/RagConversationPanel.vue'
import RagKnowledgeBasePanel from './modules/rag/RagKnowledgeBasePanel.vue'
import SiteHeader from '@/components/home/SiteHeader.vue'
import SiteFooter from '@/components/home/SiteFooter.vue'
import FloatingContactTools from '@/components/home/FloatingContactTools.vue'
import createWorkspaceMenu from '@/config/workspaceMenu'
import { authServiceClient, outRequest, userStatusRequest } from '../tools/api/auth-api'
import {
  ragServiceClient,
  RagBootstrapRequest,
  RagConversationCreateRequest,
  RagConversationDeleteRequest,
  RagConversationHistoryRequest,
  RagConversationPageRequest,
  RagConversationSendRequest,
  RagKnowledgeBaseCreateRequest,
  RagKnowledgeBaseDeleteRequest,
  RagKnowledgeBaseDetailRequest,
  RagKnowledgeBaseDocumentDeleteRequest,
  RagKnowledgeBaseDocumentPageRequest,
  RagKnowledgeBasePageRequest,
  RagKnowledgeBaseUpdateRequest,
  RagKnowledgeBaseUploadRequest
} from '../tools/api/rag-api'

// Based on the current official WeKnora engine registries:
// builtin/simple/weknoracloud/mineru/mineru_cloud and docreader markitdown.
const SUPPORTED_KNOWLEDGE_UPLOAD_EXTENSIONS = [
  'pdf',
  'doc',
  'docx',
  'md',
  'markdown',
  'txt',
  'csv',
  'json',
  'xls',
  'xlsx',
  'pptx',
  'jpg',
  'jpeg',
  'png',
  'gif',
  'bmp',
  'tiff',
  'webp',
  'mp3',
  'wav',
  'm4a',
  'flac',
  'ogg'
]
const SUPPORTED_KNOWLEDGE_UPLOAD_EXTENSION_SET = new Set(SUPPORTED_KNOWLEDGE_UPLOAD_EXTENSIONS)
const SUPPORTED_KNOWLEDGE_UPLOAD_ACCEPT = SUPPORTED_KNOWLEDGE_UPLOAD_EXTENSIONS.map(item => `.${item}`).join(',')
const SUPPORTED_KNOWLEDGE_UPLOAD_LABEL = 'PDF、DOC/DOCX、MD/MARKDOWN、TXT、CSV、JSON、XLS/XLSX、PPTX、JPG/JPEG/PNG/GIF/BMP/TIFF/WEBP、MP3/WAV/M4A/FLAC/OGG'
const workspaceMenu = createWorkspaceMenu()
const SITE_TOOL_SECTIONS = Object.keys(workspaceMenu).map(key => ({
  key,
  title: workspaceMenu[key].title,
  items: workspaceMenu[key].list
}))

export default {
  name: 'RagIndex',
  components: {
    RagConversationPanel,
    RagKnowledgeBasePanel,
    SiteHeader,
    SiteFooter,
    FloatingContactTools
  },
  data() {
    return {
      activeTab: 'conversation',
      siteToolSections: SITE_TOOL_SECTIONS,
      agents: [],
      currentAgentCode: 'SMART_REASONING',
      currentScopeId: '',
      knowledgeBaseLoading: false,
      knowledgeBaseDetailLoading: false,
      knowledgeBaseDocumentLoading: false,
      knowledgeBaseDocumentUploading: false,
      knowledgeBases: [],
      currentKnowledgeBase: null,
      knowledgeBaseDocuments: [],
      messageText: '',
      messages: [],
      scopes: [],
      selectedKnowledgeBaseIds: [],
      sessions: [],
      sending: false,
      currentSessionId: '',
      userInfo: '',
      loginLayerIndex: null
    }
  },
  computed: {
    knowledgeUploadAccept() {
      return SUPPORTED_KNOWLEDGE_UPLOAD_ACCEPT
    },
    currentScope() {
      return this.scopes.find(item => item.scopeId === this.currentScopeId) || null
    },
    hasConversationSidebar() {
      return this.sessions.length > 0
    },
    conversationSessionGroups() {
      const groups = [
        { key: 'today', label: '今天', items: [] },
        { key: 'recent', label: '近 7 天', items: [] },
        { key: 'earlier', label: '更早', items: [] }
      ]
      const startOfToday = new Date()
      startOfToday.setHours(0, 0, 0, 0)
      const sevenDaysAgo = new Date(startOfToday.getTime() - 6 * 24 * 60 * 60 * 1000)
      const sortedSessions = [...this.sessions].sort((a, b) => this.getSessionTimestamp(b) - this.getSessionTimestamp(a))

      sortedSessions.forEach(session => {
        const timestamp = this.getSessionTimestamp(session)
        if (!timestamp) {
          groups[2].items.push(session)
          return
        }
        if (timestamp >= startOfToday.getTime()) {
          groups[0].items.push(session)
          return
        }
        if (timestamp >= sevenDaysAgo.getTime()) {
          groups[1].items.push(session)
          return
        }
        groups[2].items.push(session)
      })

      return groups.filter(group => group.items.length)
    }
  },
  watch: {
    activeTab() {
      this.refreshActiveTab()
    },
    currentScopeId() {
      this.currentSessionId = ''
      this.currentKnowledgeBase = null
      this.knowledgeBaseDocuments = []
      this.messages = []
      this.selectedKnowledgeBaseIds = []
      this.refreshActiveTab()
    }
  },
  created() {
    this.bootstrapPage()
  },
  mounted() {
    if (!this.hasStoredAuthSession()) {
      this.openLoginDialog()
    }
  },
  methods: {
    navigateToSiteTool(item) {
      if (!item) {
        return
      }
      if (item.url === '/rag') {
        if (!this.hasStoredAuthSession()) {
          this.openLoginDialog()
        }
        return
      }
      if (item.url === '/trans-pro') {
        window.open('/trans-pro/index', '_self')
        return
      }
      if (item.type) {
        this.$router.push({
          path: item.url,
          query: { type: item.type }
        })
        return
      }
      this.$router.push(item.url)
    },
    selectRagTab(tab) {
      this.activeTab = tab
      if (!this.hasStoredAuthSession()) {
        this.openLoginDialog()
      }
    },
    async bootstrapPage() {
      if (!this.hasStoredAuthSession()) {
        this.syncUserInfoFromStorage()
        this.openLoginDialog()
        return
      }
      const authed = await this.ensureUserStatus()
      if (!authed) {
        return
      }
      try {
        await this.loadBootstrap()
        await this.refreshActiveTab()
      } catch (e) {
        if (this.isAuthenticationError(e)) {
          this.clearAuthStorage()
          this.openLoginDialog()
          return
        }
        this.$message.error(this.resolveRpcErrorMessage(e, 'RAG 初始化失败'))
      }
    },
    hasStoredAuthSession() {
      const token = localStorage.getItem('token')
      const authContext = localStorage.getItem('auth-context')
      if (!token || !authContext) return false
      try {
        const identities = JSON.parse(authContext)
        return Array.isArray(identities) && identities.length > 0
      } catch (e) {
        return false
      }
    },
    async ensureUserStatus({ prompt = true } = {}) {
      const metadata = this.getMetadata()
      try {
        const response = await authServiceClient.getUserStatus(userStatusRequest, metadata)
        if (!response.getStatus()) {
          this.clearAuthStorage()
          if (prompt) this.openLoginDialog()
          return false
        }
      } catch (e) {
        this.clearAuthStorage()
        if (prompt) this.openLoginDialog()
        return false
      }
      if (!localStorage.getItem('auth-context')) {
        if (prompt) this.openLoginDialog()
        return false
      }
      this.syncUserInfoFromStorage()
      return true
    },
    clearAuthStorage() {
      localStorage.removeItem('token')
      localStorage.removeItem('auth-context')
    },
    openLoginDialog() {
      if (this.loginLayerIndex !== null && this.loginLayerIndex !== undefined) {
        return
      }
      this.$nextTick(() => {
        if (this.loginLayerIndex !== null && this.loginLayerIndex !== undefined) {
          return
        }
        this.loginLayerIndex = this.$authPopup.open(process.env.VUE_APP_WEB_LOGIN_URL || '/login', {
          onClose: () => {
            this.loginLayerIndex = null
            this.syncUserInfoFromStorage()
            if (this.hasStoredAuthSession() && !this.currentScopeId) {
              this.bootstrapPage()
            }
          }
        })
      })
    },
    async requestRagAuthentication() {
      if (!this.hasStoredAuthSession()) {
        this.openLoginDialog()
        return false
      }
      return this.ensureUserStatus()
    },
    syncUserInfoFromStorage() {
      const authContext = localStorage.getItem('auth-context')
      if (!authContext) {
        this.userInfo = ''
        return
      }
      try {
        const users = JSON.parse(authContext)
        const mainUser = users.find(item => item.type === 'Person' || item.type === 'Child')
        if (mainUser) {
          this.userInfo = mainUser.realName ? Base64.decode(mainUser.realName) : mainUser.name
        }
      } catch (e) {
        this.userInfo = ''
      }
    },
    async loadBootstrap() {
      const request = new RagBootstrapRequest()
      const response = await ragServiceClient.ragBootstrap(request, this.getMetadata())
      const scopes = response.getScopesList()
        .map(this.mapScope)
        .filter(item => item.scopeType === 'PERSONAL')
      const serverAgents = response.getAgentsList().map(this.mapAgent)
      const builtinAgents = this.getBuiltinAgents().map(item => {
        const matchedAgent = serverAgents.find(agent => agent.code === item.code)
        return matchedAgent ? { ...item, ...matchedAgent } : item
      })
      this.scopes = scopes
      this.agents = builtinAgents
      this.currentScopeId = scopes.length ? scopes[0].scopeId : ''
      const defaultAgentCode = response.getDefaultAgentCode()
      const availableCodes = new Set(builtinAgents.map(item => item.code))
      this.currentAgentCode = availableCodes.has(defaultAgentCode) ? defaultAgentCode : 'SMART_REASONING'
    },
    async refreshActiveTab() {
      if (!this.currentScopeId) {
        return
      }
      if (this.currentScopeId) {
        await this.loadSessions()
      }
      if (this.activeTab === 'knowledge') {
        await this.loadKnowledgeBases()
        if (this.currentKnowledgeBase && this.currentKnowledgeBase.id) {
          await this.refreshKnowledgeBaseDetail()
        }
        return
      }
      if (this.activeTab === 'conversation') {
        await this.loadKnowledgeBases()
        if (this.currentSessionId) {
          await this.loadMessages()
        }
      }
    },
    async ensureScopeReady() {
      const authed = await this.ensureUserStatus()
      if (!authed) {
        return false
      }
      if (this.currentScopeId) {
        return true
      }
      await this.loadBootstrap()
      return !!this.currentScopeId
    },
    resolveRpcErrorMessage(error, fallbackMessage) {
      if (!error) {
        return fallbackMessage
      }
      const metadata = error.metadata || {}
      const candidates = [
        error.message,
        metadata['grpc-message'],
        metadata.message,
        metadata.details
      ]
      for (let item of candidates) {
        if (Array.isArray(item)) {
          item = item[0]
        }
        if (item) {
          return item
        }
      }
      return fallbackMessage
    },
    isAuthenticationError(error) {
      if (!error) {
        return false
      }
      const metadata = error.metadata || {}
      const code = Number(error.code || metadata.code || metadata['grpc-status'])
      if (code === 16 || code === 401) {
        return true
      }
      const message = this.resolveRpcErrorMessage(error, '').toLowerCase()
      return [
        '未登录',
        '登录状态已失效',
        '登录已失效',
        '登录过期',
        'unauthenticated',
        'unauthorized'
      ].some(keyword => message.includes(keyword))
    },
    async loadKnowledgeBases() {
      if (!this.currentScopeId && !await this.ensureScopeReady()) {
        return
      }
      this.knowledgeBaseLoading = true
      try {
        const request = new RagKnowledgeBasePageRequest()
        request.setScopeId(this.currentScopeId)
        request.setPageNum(1)
        request.setPageSize(100)
        const response = await ragServiceClient.ragKnowledgeBasePage(request, this.getMetadata())
        this.knowledgeBases = response.getKnowledgeBasesList().map(this.mapKnowledgeBase)
        const accessibleIds = new Set(this.knowledgeBases.map(item => item.id))
        this.selectedKnowledgeBaseIds = this.selectedKnowledgeBaseIds.filter(id => accessibleIds.has(id))
        if (this.currentKnowledgeBase && !accessibleIds.has(this.currentKnowledgeBase.id)) {
          this.currentKnowledgeBase = null
          this.knowledgeBaseDocuments = []
        }
      } finally {
        this.knowledgeBaseLoading = false
      }
    },
    async createKnowledgeBase(payload) {
      try {
        if (!await this.ensureScopeReady()) {
          this.$message.error('个人知识库初始化失败，请刷新页面后重试')
          return
        }
        const request = new RagKnowledgeBaseCreateRequest()
        request.setScopeId(this.currentScopeId)
        request.setName(payload.name)
        request.setDescription(payload.description || '')
        request.setType(payload.type || 'DOCUMENT')
        request.setParserStrategy(payload.parserStrategy || 'auto')
        request.setChunkStrategy(payload.chunkStrategy || 'general')
        request.setStorageProvider(payload.storageProvider || 'minio')
        const response = await ragServiceClient.ragKnowledgeBaseCreate(request, this.getMetadata())
        const knowledgeBase = this.mapKnowledgeBase(response.getKnowledgeBase())
        this.$message.success('知识库已创建')
        await this.loadKnowledgeBases()
        await this.openKnowledgeBase(knowledgeBase)
      } catch (e) {
        this.$message.error(this.resolveRpcErrorMessage(e, '创建知识库失败'))
      }
    },
    async updateKnowledgeBase(payload) {
      if (!await this.ensureScopeReady()) {
        return
      }
      try {
        const request = new RagKnowledgeBaseUpdateRequest()
        request.setScopeId(this.currentScopeId)
        request.setKnowledgeBaseId(payload.knowledgeBaseId)
        request.setName(payload.name)
        request.setDescription(payload.description || '')
        request.setParserStrategy(payload.parserStrategy || 'auto')
        request.setChunkStrategy(payload.chunkStrategy || 'general')
        request.setStorageProvider(payload.storageProvider || 'minio')
        const response = await ragServiceClient.ragKnowledgeBaseUpdate(request, this.getMetadata())
        this.currentKnowledgeBase = this.mapKnowledgeBase(response.getKnowledgeBase())
        this.$message.success('知识库配置已更新')
        await this.loadKnowledgeBases()
        await this.refreshKnowledgeBaseDocuments()
      } catch (e) {
        this.$message.error(this.resolveRpcErrorMessage(e, '更新知识库失败'))
      }
    },
    async openKnowledgeBase(row) {
      if (!row || !row.id) {
        return
      }
      this.currentKnowledgeBase = row
      await Promise.all([
        this.loadKnowledgeBaseDetail(row.id),
        this.loadKnowledgeBaseDocuments(row.id)
      ])
    },
    backToKnowledgeBaseList() {
      this.currentKnowledgeBase = null
      this.knowledgeBaseDocuments = []
    },
    async loadKnowledgeBaseDetail(knowledgeBaseId) {
      this.knowledgeBaseDetailLoading = true
      try {
        const request = new RagKnowledgeBaseDetailRequest()
        request.setScopeId(this.currentScopeId)
        request.setKnowledgeBaseId(knowledgeBaseId)
        const response = await ragServiceClient.ragKnowledgeBaseDetail(request, this.getMetadata())
        this.currentKnowledgeBase = this.mapKnowledgeBase(response.getKnowledgeBase())
      } finally {
        this.knowledgeBaseDetailLoading = false
      }
    },
    async loadKnowledgeBaseDocuments(knowledgeBaseId) {
      this.knowledgeBaseDocumentLoading = true
      try {
        const request = new RagKnowledgeBaseDocumentPageRequest()
        request.setScopeId(this.currentScopeId)
        request.setKnowledgeBaseId(knowledgeBaseId)
        request.setPageNum(1)
        request.setPageSize(100)
        const response = await ragServiceClient.ragKnowledgeBaseDocumentPage(request, this.getMetadata())
        this.knowledgeBaseDocuments = response.getDocumentsList().map(this.mapKnowledgeBaseDocument)
      } finally {
        this.knowledgeBaseDocumentLoading = false
      }
    },
    async refreshKnowledgeBaseDetail() {
      if (!this.currentKnowledgeBase || !this.currentKnowledgeBase.id) {
        await this.loadKnowledgeBases()
        return
      }
      await Promise.all([
        this.loadKnowledgeBaseDetail(this.currentKnowledgeBase.id),
        this.loadKnowledgeBaseDocuments(this.currentKnowledgeBase.id)
      ])
    },
    async refreshKnowledgeBaseDocuments() {
      if (!this.currentKnowledgeBase || !this.currentKnowledgeBase.id) {
        return
      }
      await this.loadKnowledgeBaseDocuments(this.currentKnowledgeBase.id)
    },
    readFileAsUint8Array(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsArrayBuffer(file)
        reader.onload = () => {
          resolve(new Uint8Array(reader.result))
        }
        reader.onerror = () => {
          reject(new Error('文件读取失败'))
        }
      })
    },
    extractKnowledgeUploadExtension(fileName) {
      const normalizedName = String(fileName || '').trim().toLowerCase()
      const dotIndex = normalizedName.lastIndexOf('.')
      if (dotIndex < 0 || dotIndex === normalizedName.length - 1) {
        return ''
      }
      return normalizedName.slice(dotIndex + 1)
    },
    getKnowledgeUploadDisplayName(file, isFolder) {
      if (isFolder) {
        const relativePath = String(file.webkitRelativePath || '').trim()
        if (relativePath) {
          return relativePath
        }
      }
      return file.name
    },
    collectSupportedKnowledgeFiles(files, isFolder) {
      const validFiles = []
      const invalidFiles = []
      files.forEach(file => {
        const extension = this.extractKnowledgeUploadExtension(file.name)
        if (SUPPORTED_KNOWLEDGE_UPLOAD_EXTENSION_SET.has(extension)) {
          validFiles.push(file)
          return
        }
        invalidFiles.push(this.getKnowledgeUploadDisplayName(file, isFolder))
      })
      return {
        validFiles,
        invalidFiles
      }
    },
    buildUnsupportedKnowledgeUploadMessage(invalidFiles) {
      const preview = invalidFiles.slice(0, 3).join('、')
      const suffix = invalidFiles.length > 3 ? ` 等 ${invalidFiles.length} 个文件` : ''
      const hasLegacyPpt = invalidFiles.some(fileName => /\.ppt$/i.test(String(fileName || '').trim()))
      const legacyPptTip = hasLegacyPpt ? ' 请先将 .ppt 转为 .pptx 后再上传。' : ''
      return `已拦截不支持的文件：${preview}${suffix}。当前支持 ${SUPPORTED_KNOWLEDGE_UPLOAD_LABEL}。${legacyPptTip}`.trim()
    },
    buildKnowledgeUploadName(file, isFolder) {
      if (!isFolder) {
        return file.name
      }
      const relativePath = String(file.webkitRelativePath || '').trim()
      if (!relativePath) {
        return file.name
      }
      const pathParts = relativePath.split('/').filter(Boolean)
      if (pathParts.length <= 2) {
        return file.name
      }
      return `${pathParts.slice(1, -1).join('/')}/${file.name}`
    },
    async uploadSingleKnowledgeBaseFile(knowledgeBaseId, file, fileName) {
      const fileBytes = await this.readFileAsUint8Array(file)
      const request = new RagKnowledgeBaseUploadRequest()
      request.setScopeId(this.currentScopeId)
      request.setKnowledgeBaseId(knowledgeBaseId)
      request.setName(fileName || file.name)
      request.setFile(fileBytes)
      const response = await ragServiceClient.ragKnowledgeBaseUpload(request, this.getMetadata())
      if (!response.getStatus()) {
        throw new Error(response.getMessage() || '上传失败')
      }
      return response
    },
    async uploadKnowledgeBaseFile({ row, knowledgeBaseId, files, isFolder }) {
      if (!await this.ensureScopeReady()) {
        return
      }
      const targetKnowledgeBaseId = knowledgeBaseId || (row && row.id) || ''
      if (!targetKnowledgeBaseId) {
        const error = new Error('未找到知识库')
        this.$message.error(error.message)
        return
      }
      const uploadFiles = Array.isArray(files) ? files.filter(Boolean) : []
      if (!uploadFiles.length) {
        this.$message.warning('请选择要上传的文件')
        return
      }
      const { validFiles, invalidFiles } = this.collectSupportedKnowledgeFiles(uploadFiles, !!isFolder)
      if (invalidFiles.length) {
        const message = this.buildUnsupportedKnowledgeUploadMessage(invalidFiles)
        if (validFiles.length) {
          this.$message.warning(message)
        } else {
          this.$message.error(message)
          return
        }
      }
      if (!validFiles.length) {
        this.$message.warning('请选择 WeKnora 支持解析的文件格式后再上传')
        return
      }
      this.knowledgeBaseDocumentUploading = true
      let successCount = 0
      let failCount = 0
      let lastErrorMessage = ''
      try {
        for (const file of validFiles) {
          try {
            const fileName = this.buildKnowledgeUploadName(file, !!isFolder)
            await this.uploadSingleKnowledgeBaseFile(targetKnowledgeBaseId, file, fileName)
            successCount++
          } catch (e) {
            failCount++
            lastErrorMessage = this.resolveRpcErrorMessage(e, '上传失败')
          }
        }
        if (successCount > 0) {
          await this.loadKnowledgeBases()
          if (this.currentKnowledgeBase && this.currentKnowledgeBase.id === targetKnowledgeBaseId) {
            await this.refreshKnowledgeBaseDetail()
          }
        }
        if (failCount === 0) {
          if (successCount === 1) {
            this.$message.success('文件已开始进入知识库')
          } else {
            this.$message.success(`已提交 ${successCount} 个文件到知识库`)
          }
          return
        }
        if (successCount > 0) {
          this.$message.warning(`已提交 ${successCount} 个文件，另有 ${failCount} 个上传失败`)
          return
        }
        if (lastErrorMessage.indexOf('存储引擎') > -1) {
          this.$message.error('知识库存储配置异常，请稍后重试上传')
        } else {
          this.$message.error(lastErrorMessage || '上传失败')
        }
      } finally {
        this.knowledgeBaseDocumentUploading = false
      }
    },
    async deleteKnowledgeBase(row) {
      if (!row) {
        return
      }
      if (!await this.ensureScopeReady()) {
        return
      }
      await this.$confirm(`确认移除知识库「${row.name}」吗？`, '提示', { type: 'warning' })
      try {
        const request = new RagKnowledgeBaseDeleteRequest()
        request.setScopeId(this.currentScopeId)
        request.setKnowledgeBaseId(row.id)
        request.setShareId(row.shareId || '')
        const response = await ragServiceClient.ragKnowledgeBaseDelete(request, this.getMetadata())
        if (!response.getStatus()) {
          this.$message.error(response.getMessage() || '删除失败')
          return
        }
        this.$message.success('知识库已移除')
        if (this.currentKnowledgeBase && this.currentKnowledgeBase.id === row.id) {
          this.currentKnowledgeBase = null
          this.knowledgeBaseDocuments = []
        }
        await this.loadKnowledgeBases()
      } catch (e) {
        this.$message.error(this.resolveRpcErrorMessage(e, '删除失败'))
      }
    },
    async deleteKnowledgeBaseDocument(document) {
      if (!this.currentKnowledgeBase || !this.currentKnowledgeBase.id || !document) {
        return
      }
      if (!await this.ensureScopeReady()) {
        return
      }
      await this.$confirm(`确认删除文档「${document.name}」吗？`, '提示', { type: 'warning' })
      try {
        const request = new RagKnowledgeBaseDocumentDeleteRequest()
        request.setScopeId(this.currentScopeId)
        request.setKnowledgeBaseId(this.currentKnowledgeBase.id)
        request.setDocumentId(document.id)
        const response = await ragServiceClient.ragKnowledgeBaseDocumentDelete(request, this.getMetadata())
        if (!response.getStatus()) {
          this.$message.error(response.getMessage() || '删除失败')
          return
        }
        this.$message.success('文档已删除')
        await this.refreshKnowledgeBaseDetail()
        await this.loadKnowledgeBases()
      } catch (e) {
        this.$message.error(this.resolveRpcErrorMessage(e, '删除文档失败'))
      }
    },
    async loadSessions() {
      const request = new RagConversationPageRequest()
      request.setScopeId(this.currentScopeId)
      const response = await ragServiceClient.ragConversationPage(request, this.getMetadata())
      this.sessions = response.getSessionsList().map(this.mapSession)
      const sessionExists = this.sessions.some(item => item.sessionId === this.currentSessionId)
      if (!sessionExists) {
        this.currentSessionId = this.sessions.length ? this.sessions[0].sessionId : ''
      }
    },
    async createSession() {
      if (!await this.ensureScopeReady()) {
        return null
      }
      const request = new RagConversationCreateRequest()
      request.setScopeId(this.currentScopeId)
      request.setTitle('新会话')
      request.setAgentCode(this.currentAgentCode)
      const response = await ragServiceClient.ragConversationCreate(request, this.getMetadata())
      const session = this.mapSession(response.getSession())
      this.sessions.unshift(session)
      this.currentSessionId = session.sessionId
      this.messages = []
      this.activeTab = 'conversation'
      return session
    },
    async selectSession(session) {
      this.currentSessionId = session.sessionId
      await this.loadMessages()
    },
    async openSessionFromSidebar(session) {
      if (!session || !session.sessionId) {
        return
      }
      this.currentSessionId = session.sessionId
      if (this.activeTab !== 'conversation') {
        this.activeTab = 'conversation'
        return
      }
      await this.loadMessages()
    },
    async loadMessages() {
      if (!this.currentSessionId) {
        this.messages = []
        return
      }
      const request = new RagConversationHistoryRequest()
      request.setScopeId(this.currentScopeId)
      request.setSessionId(this.currentSessionId)
      request.setLimit(50)
      const response = await ragServiceClient.ragConversationHistory(request, this.getMetadata())
      this.messages = response.getMessagesList().map(this.mapMessage)
    },
    handleKnowledgeBaseSelection(val) {
      this.selectedKnowledgeBaseIds = val
    },
    async sendMessage() {
      if (!await this.ensureScopeReady()) {
        return
      }
      const content = (this.messageText || '').trim()
      if (!content) {
        this.$message.warning('请输入问题')
        return
      }
      if (!this.currentSessionId) {
        await this.createSession()
      }
      this.sending = true
      let assistantMessageId = ''
      let streamCompleted = false
      try {
        const mentionResult = this.resolveKnowledgeBaseMentions(content)
        const request = new RagConversationSendRequest()
        request.setScopeId(this.currentScopeId)
        request.setSessionId(this.currentSessionId)
        request.setAgentCode(this.currentAgentCode)
        request.setQuery(mentionResult.query || content)
        request.setKnowledgeBaseIdsList(mentionResult.knowledgeBaseIds.length ? mentionResult.knowledgeBaseIds : this.selectedKnowledgeBaseIds)
        const currentSessionId = this.currentSessionId
        const currentTime = new Date().toISOString()
        assistantMessageId = `local-assistant-${Date.now()}`
        this.messages = [
          ...this.messages,
          this.buildLocalConversationMessage(`local-user-${Date.now()}`, content, 'user', currentTime, true),
          this.buildLocalConversationMessage(assistantMessageId, '正在思考中...', 'assistant', currentTime, false)
        ]
        this.messageText = ''
        this.selectedKnowledgeBaseIds = []
        const stream = ragServiceClient.ragConversationSend(request, this.getMetadata())
        await this.consumeConversationSendStream(stream, assistantMessageId)
        streamCompleted = true
        await this.loadSessions()
        if (this.currentSessionId === currentSessionId) {
          await this.loadMessages()
        }
      } catch (e) {
        if (assistantMessageId && !streamCompleted) {
          this.updateStreamingAssistantMessage(assistantMessageId, {
            content: '发送失败，请稍后重试',
            isCompleted: true,
            updateTime: new Date().toISOString()
          })
        }
        this.$message.error(this.resolveRpcErrorMessage(e, streamCompleted ? '会话刷新失败' : '发送失败'))
      } finally {
        this.sending = false
      }
    },
    consumeConversationSendStream(stream, assistantMessageId) {
      return new Promise((resolve, reject) => {
        let finished = false
        const finalize = () => {
          if (finished) {
            return
          }
          finished = true
          resolve()
        }
        const fail = (error) => {
          if (finished) {
            return
          }
          finished = true
          reject(error)
        }
        stream.on('data', (response) => {
          if (!response || !response.getMessage) {
            return
          }
          const message = response.getMessage()
          if (!message) {
            return
          }
          this.updateStreamingAssistantMessage(assistantMessageId, this.mapMessage(message))
        })
        stream.on('error', fail)
        stream.on('end', finalize)
      })
    },
    buildLocalConversationMessage(id, content, role, time, isCompleted) {
      return {
        id,
        content,
        role,
        createTime: time,
        requestId: '',
        updateTime: time,
        isCompleted,
        knowledgeReferencesJson: '',
        agentStepsJson: ''
      }
    },
    updateStreamingAssistantMessage(localMessageId, patch) {
      this.messages = this.messages.map(item => {
        if (item.id !== localMessageId) {
          return item
        }
        return {
          ...item,
          ...patch,
          id: localMessageId,
          content: patch.content ? patch.content : item.content,
          createTime: patch.createTime || item.createTime,
          updateTime: patch.updateTime || item.updateTime || item.createTime,
          requestId: patch.requestId || item.requestId,
          knowledgeReferencesJson: patch.knowledgeReferencesJson || item.knowledgeReferencesJson,
          agentStepsJson: patch.agentStepsJson || item.agentStepsJson,
          isCompleted: typeof patch.isCompleted === 'boolean' ? patch.isCompleted : item.isCompleted
        }
      })
    },
    async deleteSession(session) {
      await this.$confirm(`确认删除会话「${session.title}」吗？`, '提示', { type: 'warning' })
      try {
        const request = new RagConversationDeleteRequest()
        request.setScopeId(this.currentScopeId)
        request.setSessionId(session.sessionId)
        const response = await ragServiceClient.ragConversationDelete(request, this.getMetadata())
        if (!response.getStatus()) {
          this.$message.error(response.getMessage() || '删除失败')
          return
        }
        this.$message.success('会话已删除')
        if (this.currentSessionId === session.sessionId) {
          this.currentSessionId = ''
          this.messages = []
        }
        await this.loadSessions()
        if (this.currentSessionId) {
          await this.loadMessages()
        }
      } catch (e) {
        this.$message.error(this.resolveRpcErrorMessage(e, '删除会话失败'))
      }
    },
    getMetadata() {
      return {
        token: localStorage.getItem('token')
      }
    },
    handleUserCommand(command) {
      if (command === 'center') {
        window.open('https://user.wesitrans.com/account', '_blank')
        return
      }
      if (command === 'logout') {
        this.logout()
      }
    },
    async logout() {
      try {
        outRequest.setName('')
        await authServiceClient.logOut(outRequest, this.getMetadata())
      } catch (e) {
      }
      localStorage.removeItem('token')
      localStorage.removeItem('auth-context')
      this.$router.push('/index')
    },
    gotoPage(type) {
      const translateTypeMap = {
        text: 'txt',
        doc: 'doc',
        ai: 'AITranslate',
        lange: 'more',
        polish: 'polish',
        aiPPT: 'aiPPT'
      }
      if (type === 'rag') {
        this.toPath('/rag')
        return
      }
      if (translateTypeMap[type]) {
        this.$router.push({
          path: '/translate',
          query: {
            type: translateTypeMap[type]
          }
        })
      }
    },
    handleServiceCommand(command) {
      if (command === 'toTransPro') {
        this.toPath('/trans-pro')
        return
      }
      if (command === 'standLangSet') {
        this.$router.push({
          path: '/translate',
          query: {
            type: 'setting'
          }
        })
        return
      }
      if (command === 'convertDoc') {
        this.$router.push({
          path: '/translate',
          query: {
            type: 'convert'
          }
        })
        return
      }
      if (command === 'mySelfDoc') {
        this.toPath('/list-pro')
        return
      }
      if (command === 'webTranslate') {
        this.$router.push({
          path: '/translate',
          query: {
            type: 'plugin'
          }
        })
        return
      }
      if (command === 'smartClassify') {
        this.toPath('/smart-classify')
      }
    },
    toPath(url) {
      if (url === '/trans-pro') {
        window.open('/trans-pro/index', '_self')
        return
      }
      this.$router.push(url)
    },
    showIframe(url) {
      return this.$authPopup.open(url)
    },
    openRecommendations() {
      const width = $(window).width()
      if (width <= 768) {
        layer.open({
          skin: 'login-demo-class',
          area: ['948px', '625px'],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ['/recommendations', 'no']
        })
        return
      }
      layer.open({
        area: ['948px', '625px'],
        type: 2,
        title: false,
        shadeClose: true,
        anim: -1,
        content: ['/recommendations', 'no']
      })
    },
    mapScope(item) {
      return {
        scopeId: item.getScopeId(),
        name: item.getName(),
        scopeType: item.getScopeType(),
        isDefault: item.getIsDefault(),
        role: item.getRole()
      }
    },
    mapAgent(item) {
      return {
        code: item.getCode(),
        name: item.getName(),
        description: item.getDescription()
      }
    },
    getBuiltinAgents() {
      return [
        {
          code: 'FAST_QA',
          name: '快速问答',
          description: '适合直接围绕知识库做轻量问答。'
        },
        {
          code: 'SMART_REASONING',
          name: '智能推理',
          description: '适合处理更复杂的分析与推理问题。'
        }
      ]
    },
    mapKnowledgeBase(item) {
      return {
        id: item.getId(),
        name: item.getName(),
        description: item.getDescription(),
        scopeId: item.getScopeId(),
        createTime: item.getCreateTime(),
        updateTime: item.getUpdateTime(),
        knowledgeCount: item.getKnowledgeCount(),
        shareId: item.getShareId(),
        permission: item.getPermission(),
        ownerUserName: item.getOwnerUserName(),
        type: item.getType(),
        documentCount: item.getDocumentCount(),
        processingCount: item.getProcessingCount(),
        parserStrategy: item.getParserStrategy(),
        chunkStrategy: item.getChunkStrategy(),
        storageProvider: item.getStorageProvider()
      }
    },
    mapKnowledgeBaseDocument(item) {
      return {
        id: item.getId(),
        name: item.getName(),
        sourceType: item.getSourceType(),
        status: item.getStatus(),
        fileSize: item.getFileSize(),
        updateTime: item.getUpdateTime(),
        errorMessage: item.getErrorMessage()
      }
    },
    mapSession(item) {
      return {
        sessionId: item.getSessionId(),
        title: item.getTitle(),
        scopeId: item.getScopeId(),
        agentCode: item.getAgentCode(),
        createTime: item.getCreateTime(),
        updateTime: item.getUpdateTime()
      }
    },
    mapMessage(item) {
      return {
        id: item.getId(),
        content: item.getContent(),
        role: item.getRole(),
        createTime: item.getCreateTime(),
        requestId: item.getRequestId(),
        updateTime: item.getUpdateTime(),
        isCompleted: item.getIsCompleted(),
        knowledgeReferencesJson: item.getKnowledgeReferencesJson(),
        agentStepsJson: item.getAgentStepsJson()
      }
    },
    resolveKnowledgeBaseMentions(content) {
      const text = String(content || '')
      const selected = []
      let query = text
      const sortedKnowledgeBases = [...(this.knowledgeBases || [])].sort((a, b) => String(b.name || '').length - String(a.name || '').length)
      sortedKnowledgeBases.forEach(item => {
        const name = String(item.name || '')
        if (!name) {
          return
        }
        const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const pattern = new RegExp(`(^|\\s)@${escapedName}(?=\\s|$)`, 'g')
        if (pattern.test(query)) {
          selected.push(item.id)
          query = query.replace(pattern, (match, prefix) => (prefix || ' '))
        }
      })
      query = query.replace(/\s+/g, ' ').trim()
      return {
        query,
        knowledgeBaseIds: Array.from(new Set(selected.filter(Boolean)))
      }
    },
    getSessionTimestamp(session) {
      const rawValue = session.updateTime || session.createTime
      if (!rawValue) {
        return 0
      }
      const normalizedValue = String(rawValue)
        .replace('T', ' ')
        .replace(/\.\d+$/, '')
        .replace(/-/g, '/')
      const timestamp = new Date(normalizedValue).getTime()
      return Number.isNaN(timestamp) ? 0 : timestamp
    }
  }
}
</script>

<style lang="less" scoped src="../assets/v2/css/trans/common.less"/>
<style lang="less" scoped src="../assets/v2/css/rag/workbench.less"/>
<style scoped>
.rag-workbench-page,
.rag-workbench-page > .group_1,
.rag-workbench-page > .group_1 > .box_1 {
  min-height: 100vh;
}

.site-tool-sidebar {
  box-sizing: border-box;
  border-right: 1px solid var(--border);
  background: linear-gradient(180deg, var(--bg-card) 0%, var(--primary-alpha-05) 100%);
}

.site-tool-section + .site-tool-section {
  position: relative;
  margin-top: 8px;
  padding-top: 7px;
}

.site-tool-section + .site-tool-section::before {
  position: absolute;
  top: 0;
  right: 8px;
  left: 8px;
  height: 1px;
  background: var(--border);
  content: "";
}

.site-tool-section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 8px 8px;
  color: var(--foreground);
  font-size: 15px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.04em;
}

.site-tool-section-title::before {
  flex: 0 0 3px;
  width: 3px;
  height: 14px;
  border-radius: 999px;
  background: var(--primary-gradient);
  box-shadow: 0 2px 6px var(--primary-alpha-22);
  content: "";
}

.site-tool-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
  min-height: 42px;
  margin: 0 0 4px;
  padding: 0 8px;
  overflow: hidden;
  box-sizing: border-box;
  color: var(--muted-foreground);
  border: 1px solid transparent;
  border-radius: 9px;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition: color 0.16s ease, border-color 0.16s ease, background-color 0.16s ease, box-shadow 0.16s ease;
}

.site-tool-icon {
  flex: 0 0 18px;
  width: 18px;
  color: var(--muted-foreground);
  font-size: 16px;
  text-align: center;
  transition: color 0.16s ease;
}

.site-tool-name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  line-height: 40px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.site-tool-item:not(.active):hover,
.site-tool-item:not(.active):focus-visible {
  color: var(--primary-dark);
  border-color: var(--primary-alpha-14);
  background: var(--primary-alpha-08);
  box-shadow: var(--shadow-md);
}

.site-tool-item:not(.active):hover .site-tool-icon,
.site-tool-item:not(.active):focus-visible .site-tool-icon {
  color: var(--primary);
}

.site-tool-item:focus-visible {
  outline: 2px solid var(--primary-alpha-30);
  outline-offset: 1px;
}

.site-tool-item.active {
  color: #ffffff;
  border-color: transparent;
  background: var(--primary);
  box-shadow: var(--shadow-primary);
}

.site-tool-item.active .site-tool-icon,
.site-tool-item.active .site-tool-name {
  color: #ffffff;
  font-weight: 600;
}

@media (min-width: 768.01px) {
  .rag-workbench-page {
    width: 100%;
    height: 100vh;
    height: 100dvh;
    min-width: 0;
    min-height: 640px;
    overflow: hidden;
    background: #f5f7fa;
  }

  .rag-workbench-page > .group_1,
  .rag-workbench-page > .group_1 > .box_1 {
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 0;
    background: #f5f7fa;
  }

  .rag-workbench-page > .group_1 > .box_1 {
    justify-content: flex-start !important;
    margin: 0 !important;
  }

  .rag-workbench-page .group_3 {
    flex: 1 1 auto;
    align-items: stretch;
    width: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
    margin: 0 !important;
    overflow: hidden;
  }

  .rag-workbench-page .new-container {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    width: 100% !important;
    height: 100%;
    min-width: 0;
    min-height: 0;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
    border-radius: 0;
    box-shadow: none;
  }

  .rag-workbench-page .box_5 {
    display: flex;
    flex: 1 1 auto;
    width: 100% !important;
    height: 100%;
    min-width: 0;
    min-height: 0;
  }

  .rag-workbench-page .site-tool-sidebar {
    flex: 0 0 200px;
    width: 200px;
    height: 100%;
    min-height: 0;
    padding: 14px 14px 24px;
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-color: var(--primary-alpha-24) transparent;
    scrollbar-width: thin;
  }

  .rag-workbench-page .site-tool-sidebar::-webkit-scrollbar {
    width: 5px;
  }

  .rag-workbench-page .site-tool-sidebar::-webkit-scrollbar-track {
    background: transparent;
  }

  .rag-workbench-page .site-tool-sidebar::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: var(--primary-alpha-24);
  }

  .rag-workbench-page .box_5 > .menu {
    flex: 0 0 200px;
    width: 200px !important;
    height: 100%;
    min-height: 0;
    margin: 0 !important;
    padding: 18px 14px 24px !important;
    overflow-x: hidden;
    overflow-y: auto;
    background: #ffffff;
  }

  .rag-workbench-page .box_5 > .menu.menu-conversation {
    flex-basis: 280px;
    width: 280px !important;
  }

  .rag-workbench-page .rag-main {
    flex: 1 1 auto;
    height: 100%;
    min-width: 0;
    min-height: 0 !important;
    overflow: auto;
  }

  .rag-workbench-page .rag-main /deep/ .conversation-main {
    height: 100%;
    min-height: 0;
    box-sizing: border-box;
  }

  .rag-workbench-page .rag-site-footer {
    position: relative;
    z-index: 20;
    display: block;
    flex: 0 0 64px;
    width: 100%;
    min-height: 64px;
    margin-top: 0;
  }

}

@media (max-width: 768px) {
  .rag-workbench-page .box_5 > .rag-menu,
  .rag-workbench-page .box_5 > .rag-menu.menu-conversation {
    flex: none !important;
    width: 100% !important;
    min-width: 0 !important;
  }

  .rag-workbench-page .site-tool-sidebar {
    display: flex;
    width: 100%;
    min-width: 0;
    padding: 10px 12px;
    overflow-x: auto;
    overflow-y: hidden;
    border-right: 0;
    border-bottom: 1px solid var(--border);
    overscroll-behavior-x: contain;
    scrollbar-width: thin;
  }

  .rag-workbench-page .site-tool-section {
    display: flex;
    flex: 0 0 auto;
    margin: 0;
    padding: 0;
  }

  .rag-workbench-page .site-tool-section + .site-tool-section {
    margin-left: 8px;
  }

  .rag-workbench-page .site-tool-section + .site-tool-section::before,
  .rag-workbench-page .site-tool-section-title {
    display: none;
  }

  .rag-workbench-page .site-tool-list {
    display: flex;
    gap: 8px;
  }

  .rag-workbench-page .site-tool-item {
    flex: 0 0 82px;
    width: 82px;
    min-height: 58px;
    margin: 0;
    padding: 7px 6px;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    text-align: center;
    border-color: var(--border);
    background: #ffffff;
  }

  .rag-workbench-page .site-tool-icon {
    flex-basis: auto;
    width: auto;
    font-size: 18px;
  }

  .rag-workbench-page .site-tool-name {
    flex: 0 0 auto;
    width: 100%;
    font-size: 12px;
    line-height: 18px;
  }

  .rag-workbench-page .rag-site-footer {
    display: block;
    width: 100%;
  }
}
</style>
